import { useSelector } from 'react-redux';

import { RootState } from '../store';

export const useStatusEditProjects = () => {
    const gantEditScheduleItem = useSelector<
        RootState,
        | {
              userId: string;
              projectId: string;
          }[]
        | undefined
    >((state) => state.gant.settingGant?.data.gantEditScheduleItem);
    const authorId = useSelector<RootState, string>((state) => state.gant.authorId);

    return new Set(
        (gantEditScheduleItem || []).filter((item) => item.userId === authorId).map((item) => item.projectId),
    );
};
